import { createOrUpdateBorrower } from '@/apiCalls/borrower';
import { DisplayButtons } from '@/components/DisplayButtons';
import {
    ECondition,
    EUserFlow,
    EVehicleAssetType,
    selectVehicleAssetType,
    selectVehicleCondition,
    setIsVehicleRegistrationKnown,
} from '@/context/borrower';
import {
    EDisplays,
    selectIsAssetKnownViaParams,
    selectPartner,
    selectPartnerOverwriteId,
    selectPreviousDisplay,
    setDisplay,
} from '@/context/display';
import { useAppDispatch, useAppSelector } from '@/context/storeHooks';
import { loanGetNextScreen } from '@/utils/loanGetNextScreen';

interface LoanButtonsPropsInterface {
    baseId?: string;
}

export function LoanButtons({
    baseId,
}: LoanButtonsPropsInterface): JSX.Element {
    const dispatch = useAppDispatch();
    const { showQuickQuote, userFlow, storeSelectorId } =
        useAppSelector(selectPartner);
    const partnerOverwriteId = useAppSelector(selectPartnerOverwriteId);
    const isVehicleNew =
        useAppSelector(selectVehicleCondition) === ECondition.NEW;
    const previousDisplay = useAppSelector(selectPreviousDisplay);
    const isAssetKnownViaParams = useAppSelector(selectIsAssetKnownViaParams);

    const wasPreviousDisplayIndicativelyApproved =
        previousDisplay === EDisplays.INDICATIVELY_APPROVED;
    const isAssetTypeEquipment =
        useAppSelector(selectVehicleAssetType) ===
        EVehicleAssetType.PLANT_EQUIPMENT;
    function handleRightClick(): void {
        createOrUpdateBorrower();
        if (isAssetTypeEquipment) {
            dispatch(setDisplay(EDisplays.MANUAL_VEHICLE));
            return;
        }
        if (!isAssetKnownViaParams && isVehicleNew) {
            dispatch(setIsVehicleRegistrationKnown(false));
        }
        if (!isAssetKnownViaParams && !isVehicleNew) {
            dispatch(setIsVehicleRegistrationKnown(true));
        }
        if (wasPreviousDisplayIndicativelyApproved) {
            dispatch(setDisplay(EDisplays.PREPPROVAL_ANIMATION));
            return;
        }
        const nextScreen = loanGetNextScreen();
        dispatch(setDisplay(nextScreen));
    }

    function handleLeftClick(): void {
        createOrUpdateBorrower();
        const backScreen = getBackScreen();
        dispatch(setDisplay(backScreen));
    }

    function getBackScreen(): EDisplays {
        if (storeSelectorId && !partnerOverwriteId) {
            return EDisplays.STORE_SELECTOR;
        }
        if (userFlow !== EUserFlow.NO_LENDER && showQuickQuote)
            return EDisplays.QUICK_CALCULATOR;
        return EDisplays.NO_LENDER_HOME;
    }

    return (
        <DisplayButtons
            idLeftButton={`${baseId}-button-back`}
            idRightButton={`${baseId}-button-next`}
            rightClick={handleRightClick}
            leftClick={handleLeftClick}
        />
    );
}
